// Email and phone regex patterns
export const emailRegex = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*/g;
export const phoneRegex = /\b(?:(?:\+|00)\d{1,3}[\s().-]*)?(?:\(?\d{2,4}\)?[\s().-]*){2,4}\d{2,4}\b/g;

/**
 * Normalize email for deduplication
 * Handles Gmail dot removal and lowercase conversion
 */
export const normalizeEmail = (email) => {
  const lower = email.toLowerCase().trim();
  const [local, domain] = lower.split('@');
  
  // Remove dots from Gmail addresses for deduplication
  if (domain === 'gmail.com') {
    return local.replace(/\./g, '') + '@' + domain;
  }
  
  return lower;
};

/**
 * Normalize phone number to E.164 format
 */
export const normalizePhone = (phone) => {
  if (!phone) return phone;
  const trimmed = phone.toString().trim();
  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 0) {
    return trimmed;
  }

  // Handle NANP numbers
  if (digits.length === 10) {
    return `+1${digits}`;
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }

  if (trimmed.startsWith('+') || trimmed.startsWith('00')) {
    return `+${digits}`;
  }

  if (digits.length >= 9) {
    return `+${digits}`;
  }

  return trimmed;
};

/**
 * Validate email address format
 */
export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

/**
 * Deduplicate contacts based on normalized email/phone
 * Merges data from duplicates
 */
export const deduplicateContacts = (newContacts, existingContacts) => {
  const seen = new Map();
  const all = [...existingContacts, ...newContacts];
  
  all.forEach(contact => {
    if (contact.email) {
      const normalized = normalizeEmail(contact.email);
      
      if (!seen.has(normalized)) {
        seen.set(normalized, contact);
      } else {
        // Merge data from duplicate
        const existing = seen.get(normalized);
        if (!existing.firstName && contact.firstName) {
          existing.firstName = contact.firstName;
        }
        if (!existing.lastName && contact.lastName) {
          existing.lastName = contact.lastName;
        }
        if (!existing.phone && contact.phone) {
          existing.phone = contact.phone;
        }
        if (!existing.company && contact.company) {
          existing.company = contact.company;
        }
      }
    } else if (contact.phone) {
      const normalized = normalizePhone(contact.phone);
      
      if (!seen.has(normalized)) {
        seen.set(normalized, contact);
      }
    }
  });
  
  return Array.from(seen.values());
};

/**
 * Export contacts to CSV format
 */
export const formatContactsForExport = (contacts) => {
  return contacts.map(c => ({
    Email: c.email || '',
    Phone: c.phone || '',
    'First Name': c.firstName || '',
    'Last Name': c.lastName || '',
    Company: c.company || '',
    Status: c.status,
    Source: Array.isArray(c.sources) && c.sources.length ? c.sources.join('; ') : (c.source || ''),
    'Email marketing status': c.emailMarketingStatus || '',
    'TradeIT Day registered': c.tradeitDayRegistered ? 'yes' : 'no',
    'TradeIT Day registered at': c.tradeitDayRegisteredAt || '',
    'Residency applied': c.residencyApplied ? 'yes' : 'no',
    'Admissions call booked': c.admissionsCallBooked ? 'yes' : 'no',
    'Residency enrolled': c.residencyEnrolled ? 'yes' : 'no',
    'Society member': c.societyMember ? 'yes' : 'no',
    'Trndline user': c.trndlineUser ? 'yes' : 'no',
    'Created At': c.createdAt
  }));
};
